module.exports = __webpack_public_path__ + "media/images/banner-assets/th/banner4-043c91b32bf68138e2fe1e5c4f0597b5.jpg";